
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

var RecruitApplyPage = Vue.extend({})
Vue.component('recruitApply-page', RecruitApplyPage)

export default {
name: 'RecruitApplyPage',
components: {
XTable,XButton,XDialog,Group,XInput,CellBox,Radio,PopupHeader,Popup,XTextarea,Flexbox,FlexboxItem,Datetime
},
directives: {
TransferDom
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
refRecordId: '',
refModule: '',
showToast: false,//弹窗-dialog

luyongPeople: '',
birthday: '',
specialty: '',
education: '',
graduateSchool: '',
carInfo: '',
positionLevel: '',
toDate: '',
toRealDate: '',
tryMoney: '',
formalMoney: '',
belongLeader: '',
belongLeaderId: '',
workAddress: '',
jobRequire: '',

checkTreeShow: false,
treeData: [],//人员结构树
checkTreeSearchVal: '',//人员结构树搜索内容
checkTreeSearchResult: [],//人员结构树搜索结果
treeProps: {
children: 'children',
label: 'name'
},
checkDeptResult: {},//人员结构树-选择结果

selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: '',

sexList: [
{id:'1',name:'男'},
{id:'0',name:'女'},
],//变动情况
sexValue: '',
sex: '',
sexId: '',

educationList: [],
educationValue: '',
education: '',
educationId: '',

tryModelList: [],
tryModelValue: '',
tryModel: '',
tryModelId: '',

tryMonthList: [
{id:'0',name:''},
{id:'1',name:'1个月'},
{id:'2',name:'2个月'},
{id:'3',name:'3个月'},
{id:'6',name:'6个月'},
{id:'7',name:'其他月份'},
],
tryMonthValue: '',
tryMonth: '',
tryMonthId: '',

positionLevelList: [],//职级
positionLevelValue: '',
positionLevel: '',
positionLevelId: '',//职级ID

jobList: [],//职务
jobValue: '',
job: '',
jobId: '',//职务ID

fileObj: {},//文件上传集合
fileShowList: [],//上传文件集合-预览
uploadedFileIdList: [],//已上传文件ID集合

}
},
mounted () {
this.$emit('sendTitleToParent','人员录用申请');
this.axios({
url: this.baseUrl+'/wechat/personnelEmploy/employApply',
method: 'get'
}).then((response) => {
console.log(response.data);
this.info = response.data.obj;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
}).catch((response) => {
this.$vux.loading.hide();
});
this.getEducation();
this.getTryModel();
this.getPositionLevel();
this.getJob();
},
methods: {
openDialog () {// 打开选择业务-dialog
this.showToast = true;
this.getDeptTree();
},
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
getDeptTree () {//获取人员架构
this.axios({
url: this.baseUrl+'/wechat/staff/getOrgStaff',
method: 'get'
}).then((response) => {
this.treeData = response.data;
this.checkTreeShow = true;
}).catch((response) => {
this.$vux.loading.hide();
});
},
clearSearchResult () {//清空搜索栏
this.checkTreeSearchResult = [];
},
clearDeptResult () {//清除组织架构
this.employeeName = '';
this.checkDeptResult = {};
},
getArray (data,name) {//组织架构搜索-递归
for (var i in data) {
if (data[i].name == name || data[i].name.indexOf(name) != -1) {
this.checkTreeSearchResult.push(data[i]);
}else {
this.getArray(data[i].children, name);
}
}
},
addToTree (item) {//将搜索结果添加到树
let CheckedNodes = this.$refs.tree.getCheckedNodes();
CheckedNodes.push(item);
this.$refs.tree.setCheckedNodes(CheckedNodes);
this.checkTreeSearchResult = [];
},
getCheckedNodes() {//选择-人员架构树

let checkedPersonArr = this.$refs.tree.getCheckedNodes();

this.checkDeptResult = checkedPersonArr[0];
this.belongLeader = this.checkDeptResult.name;
this.belongLeaderId = this.checkDeptResult.id;
this.checkTreeShow = false;
this.showToast = false;
console.log('组织架构树',this.checkDeptResult,this.belongLeader);
},
treeSearch () {//提交-组织架构搜索按钮
this.checkTreeSearchResult = [];
let checkTreeSearchVal = this.checkTreeSearchVal;
let treeData = this.treeData;
if(checkTreeSearchVal!=''){
this.getArray(treeData,checkTreeSearchVal);
}
},
openSelectModelFlage(type,data){
console.log('openSelectModelFlage',type,data);
this.selectModelData = [];
if(type == 'sex'){
this.selectModelTitle = '请选择性别';
this.selectModel = this.sex;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'education'){
this.selectModelTitle = '请选择学历';
this.selectModel = this.educationValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'tryModel'){
this.selectModelTitle = '请选择转正工资模式';
this.selectModel = this.tryModelValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'positionLevel'){
this.selectModelTitle = '请选择职级';
this.selectModel = this.positionLevelValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'job'){
this.selectModelTitle = '请选择职务';
this.selectModel = this.jobValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'tryMonth'){
this.selectModelTitle = '请选择试用期限';
this.selectModel = this.tryMonthValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}
this.selectModelFlag = true;
},
getLeaveType (value, label) {

this.accountUniId = value;

let isChange = value == this.selectModel ? false : true
if(this.selectModelTitle == '请选择性别'){
this.selectModel = this.sexValue = value;
this.sex = label;
} else if(this.selectModelTitle == '请选择学历') {
this.selectModel = this.educationValue = value;
this.education = label;
} else if(this.selectModelTitle == '请选择转正工资模式'){
this.selectModel = this.tryModelValue = value;
this.tryModel = label;
} else if(this.selectModelTitle == '请选择职级'){
this.selectModel = this.positionLevelValue = value;
this.positionLevel = label;
} else if(this.selectModelTitle == '请选择职务'){
this.selectModel = this.jobValue = value;
this.job = label;
} else if(this.selectModelTitle == '请选择试用期限'){
this.selectModel = this.tryMonthValue = value;
this.tryMonth = label;
}
if(isChange){
this.selectModelFlag = false;
}
console.log(this.selectModel)
},

async getEducation () {//获取职级

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listBaseDatas/EDUCATION',
method: 'get'
});

let list = res.data.list;
this.educationList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.educationList.push(list[i]);
}
},


async getTryModel () {

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/salaryModel/zhuanzhen',
method: 'get'
});

let list = res.data.list;
this.tryModelList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.tryModelList.push(list[i]);
}
},


async getPositionLevel () {//获取职级

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listBaseDatas/POSITION_LEVEL',
method: 'get'
});

let list = res.data.list;
this.positionLevelList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.positionLevelList.push(list[i]);
}

},

async getJob () {//获取职务

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listValidRank',
method: 'get'
});
let list = res.data.list;
this.jobList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.jobList.push(list[i]);
}

},

chooseDate (v) {
let that = this;
let valueStr = this+'.'+v;
if(v === 'birthday'){
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.birthday,
onConfirm (val) {
that.birthday = val;
}
})
}else if(v === 'toDate'){
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.toDate,
onConfirm (val) {
that.toDate = val;
}
})
}else if(v === 'toRealDate'){
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.toRealDate,
onConfirm (val) {
that.toRealDate = val;
}
})
}
},
chooseFile () { // 选择附件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
})
this.submitFile();
},
deleteFile (index) { // 删除已选附件
this.fileShowList.splice(index, 1)

let deleteFileId = this.uploadedFileIdList[index]
let fileData = new FormData()
fileData.append('fileId', deleteFileId)
this.$vux.loading.show({
text: '删除中'
});
this.axios({
url: this.baseUrl + '/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
this.$vux.loading.hide();
this.uploadedFileIdList.splice(index, 1)
}).catch((response) => {
this.$vux.loading.hide()
})
},
async submitFile () { // 上传附件-图片
let fileObjL = this.fileObj.length;
for (let i = 0; i < fileObjL; i++) {
let fileData = new FormData()
fileData.append('file', this.fileObj[i])
fileData.append('taskId', this.info.id)
fileData.append('refRecordId', this.refRecordId)
fileData.append('refModule', this.refModule)
let res = await this.axios({
url: this.baseUrl + '/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
})
this.uploadedFileIdList.push(res.data.fileId)

let that = this
let file = this.fileObj[i]
let reader = new FileReader()
reader.readAsDataURL(file)
reader.onload = function (e) {
that.fileShowList.push(this.result)
}
}

this.$vux.loading.hide()
},
saveForm () {//保存
this.$vux.loading.show({
text: '加载中'
});

let formData = new FormData();
formData.append("id",this.info.id);

formData.append("luyongPeople",this.luyongPeople);
formData.append("birthday",this.birthday);
formData.append("sex",this.sexValue);
formData.append("specialty",this.specialty);
formData.append("education",this.education);

formData.append("graduateSchool",this.graduateSchool);
formData.append("carInfo",this.carInfo);

formData.append("job",this.job);
formData.append("positionLevel",this.positionLevel);
formData.append("toDate",this.toDate);
formData.append("toRealDate",this.toRealDate);
formData.append("tryMoney",this.tryMoney);

formData.append("tryMonth",this.tryMonthValue);
formData.append("tryModel",this.tryModelValue);
formData.append("formalMoney",this.formalMoney);
formData.append("belongLeader",this.belongLeaderId);
formData.append("workAddress",this.workAddress);
formData.append("jobRequire",this.jobRequire);

this.axios({
url: this.baseUrl+'/wechat/personnelEmploy/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData,
}).then((response) => {
console.log('人员录用saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
this.axios({
url: this.baseUrl+'/wechat/loan/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

},
}
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/recruitApply.vue